import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/about.scss";

function About() {
  const sections = [
    {
      title: "REGEN SILK NOIL JERSEY",
      image: "/main/a1.webp",
      caption: "Fig. 1 Lou Tee, Regen Silk Noil Jersey, Natural",
      paragraphs: [
        "Our signature Silk Noil Jersey has a vintage aesthetic and nubby feel, similar to its woven cousin. It travels well and can be your favorite summer staple and cold‑weather base layer.",
        "Made from regeneratively produced silk, enriching rather than depleting soils and creating a sustainable, eco‑friendly textile.",
        "Care: Hand wash in cold water with gentle detergent; lay flat to dry. Low iron or steam if needed.",
      ],
      reverse: false,
    },
    {
      title: "TENCEL BULL DENIM",
      image: "/main/a2.webp",
      caption: "Fig. 2 Marcie Shirt, Tencel Denim, Vintage Dark",
      paragraphs: [
        "Soft yet structured, our Tencel Bull Denim is comfortable and durable. Cotton is ethically and responsibly sourced with verified origin.",
        "Tencel adds drape, strength and softness. The process is closed loop and water‑efficient with low ecological impact.",
        "Care: Machine wash on cold with gentle detergent. Tumble dry low or line dry; warm iron as needed.",
      ],
      reverse: true,
    },
    {
      title: "ORGANIC COTTON POPLIN",
      image: "/main/a3.webp",
      caption: "Fig. 3 Poplin Field Pant, Khaki",
      paragraphs: [
        "Our Organic Poplin is crafted from 100% organically grown cotton, without synthetic chemicals or growth promoters.",
        "Supports biodiversity and environmental cycles; softer and more comfortable to wear than conventional cotton.",
        "Care: Hand wash or gentle machine wash in lukewarm or cold water using mild detergent. Tumble dry low or line dry.",
      ],
      reverse: false,
    },
    {
      title: "ALPACA & ORGANIC COTTON KNITS",
      image: "/main/a4.webp",
      caption: "Fig. 4 Elia Crew, Organic Cotton, Ecru",
      paragraphs: [
        "Our Fair Trade Knits are made from fine Alpaca and organic cotton blends. Hypoallergenic and known for strength, softness and durability.",
        "Organic cotton supports free trade and ethical practices; alpaca ranching has relatively low environmental impact.",
        "Care: Hand wash with gentle detergent, soak up to 30 minutes, rinse in cool water. Do not wring; press water out and lay flat to dry.",
      ],
      reverse: true,
    },
    {
      title: "REGEN SILK",
      image: "/main/a5.webp",
      caption: "Fig. 5 1930s Bandana, Regen Silk, Hay",
      paragraphs: [
        "Regenerative silk prioritizes environmental and social well‑being, restoring ecosystems and communities where silk is produced.",
        "Our bandanas are made from regenerative silk and printed locally using certified dyes.",
        "Care: Machine wash warm with gentle detergent and tumble dry low.",
      ],
      reverse: false,
    },
  ];
  return (
    <div className="about">
      <Header />

      <main className="about-content">
        <h1 className="about-title">Textile Guide and Care Instructions</h1>

        {sections.map((s, idx) => (
          <section
            className={`about-row ${s.reverse ? "reverse" : ""}`}
            key={s.title + idx}
          >
            <div className="about-text">
              <h2 className="about-heading">{s.title}</h2>
              {s.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
            <figure className="about-figure">
              <img src={s.image} alt={s.title} />
              <figcaption>{s.caption}</figcaption>
            </figure>
          </section>
        ))}
      </main>

      <Footer />
    </div>
  );
}

export default About;
